import { combineReducers, createStore } from "redux";
import reducers, { AppReduxState } from "./reducers";
import react_tools_reducers from "@acri-tools/react-tools/redux/reducers";
import react_tools_store, { RTReduxState } from '@acri-tools/react-tools/redux';

const store = createStore(
    combineReducers({
        ...reducers,
        ...react_tools_reducers
    })
);
react_tools_store.store = store

export type ReduxState = RTReduxState & AppReduxState

export const getReduxState = (): ReduxState =>{
    return store.getState();
}
export default store;